// Put the collection's discount code on the shopper's session, so the cart and
// the checkout charge what the collection page showed.
//
// The strike-through is only a drawing. What a shopper actually pays is decided
// by Shopify, and the only way a theme can ask for a code is /discount/<code>,
// which sets it on the session and redirects. Fetching it has the same effect
// without taking the shopper anywhere.
//
// Applied once per code per tab: the cookie persists for the session, so asking
// again on every page of a drop would be a request per page for no change. A
// different code (a second collection, or one edited in admin) is applied again,
// because the newest one is the one being shown.
//
// Liquid decides WHETHER to emit the code at all — only inside the collection's
// own preview-to-close window, and only for a discount the resolver verified as
// live, unconditional and open to everyone. So this never applies a code the
// page is not already pricing by.
const MARK = 'data-apply-discount';
const REMEMBERED = 'sylvie:discount-applied';

async function applyDiscount() {
	const holder = document.querySelector(`[${MARK}]`);
	if (!holder) return;
	const code = holder.getAttribute(MARK);
	if (!code) return;

	let seen = null;
	try {
		seen = sessionStorage.getItem(REMEMBERED);
	} catch (e) {
		// Private browsing, or storage blocked. Applying every page is worse than
		// applying once, but it is not wrong — carry on without the memory.
	}
	if (seen === code) return;

	try {
		// same-origin so the cookie Shopify sets comes back with the response.
		await fetch(`/discount/${encodeURIComponent(code)}`, { credentials: 'same-origin' });
		try {
			sessionStorage.setItem(REMEMBERED, code);
		} catch (e) {}
	} catch (e) {
		// The price on the page stands either way; the shopper can still enter the
		// code at checkout. Nothing here should break the page.
		console.warn('[sale] could not apply the collection discount', e);
	}
}

document.addEventListener('DOMContentLoaded', applyDiscount);
